// Boot pre-warm: pay first-use costs during the idle post-spawn second instead
// of mid-play. Two hitch sources on UHD 600-class Chromebooks:
//
// 1. Shader programs compile the first time a material is rendered. Pools that
//    are invisible at boot (wizard spell fx, lightning bolts, lantern glows,
//    sun/moon sprites) would otherwise stall the frame — often hundreds of ms
//    on slow GPUs — the first time they appear. renderer.compile() traverses
//    the whole scene (not just visible objects), and compileAsync() does it
//    without blocking where KHR_parallel_shader_compile is available.
// 2. Textures upload to the GPU on first bind. Chocky's six expression
//    canvases are baked at load but only 'happy' is bound, so his first blink
//    used to pay an upload stall; renderer.initTexture() uploads them now.
//
// Not covered on purpose: wolves/SKULLFACE/eggs are spooky-gated lazy spawns
// whose Lambert/Basic variants match programs the village already compiled, so
// warming them would only cost boot time.

// Schedule the warm a few frames after the world is ready, so it can never
// inflate time-to-first-paint — the loading screen is already gone and the
// player is watching the village, not a spinner.
export function schedulePrewarm({ renderer, scene, camera, getTextures }) {
  let frames = 3;
  const run = () => {
    if (--frames > 0) { requestAnimationFrame(run); return; }
    const t0 = performance.now();
    const textures = (getTextures && getTextures()) || [];
    for (const tex of textures) { if (tex) renderer.initTexture(tex); }
    const done = (mode) => {
      console.log(`[perf] prewarm (${mode}): ${textures.length} textures, ${Math.round(performance.now() - t0)}ms`);
    };
    if (typeof renderer.compileAsync === 'function') {
      renderer.compileAsync(scene, camera).then(() => done('async')).catch(() => {
        renderer.compile(scene, camera);   // async path failed — pay it now, once
        done('sync');
      });
    } else {
      renderer.compile(scene, camera);
      done('sync');
    }
  };
  requestAnimationFrame(run);
}

// Upload one late-arriving texture (e.g. an artist face-override PNG) so its
// first bind doesn't stall a play-mode frame.
export function prewarmTexture(renderer, tex) {
  if (renderer && tex) renderer.initTexture(tex);
}
